export default __webpack_public_path__ + "static/media/warning--skiers--g2.e0e46119.png";